module.exports = __webpack_public_path__ + "media/images/pepsi_home/neon_okras-dafb9fdd1dbfedf36bcf880e43ae2b9a.png";